import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useValidator } from '../hooks/useValidator'; // Assuming you have a validator hook
import { useMessage } from '../hooks/useMessage'; // Assuming you have a message hook
import api from '../api';

const FeedbackView = ({ show, onClose }) => {
  
    const [feedback, setFeedback] = useState({
        canContact: false,
    });
    const [pageErrs, setPageErrs] = useState([]);
    const [errors, setErrors] = useState({});
    const validator = useValidator();
    const message = useMessage();
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);

    const validation = {
        name: "Please enter your name.",
        canContact: {
            condition: true,
            children: {
                email: {
                    required: "Please enter your email address.",
                    type: {
                        email: "Please enter a valid email address.",
                    },
                },
            },
        },
        text: "Please enter your feedback.",
    };

    useEffect(() => {
        if (process.env.NODE_ENV !== "development") {
            window.onerror = logError;
        }
    }, []);

    const logError = (msg, url, lineNo, columnNo, error) => {
        setPageErrs(prevErrs => [...prevErrs, { msg, url, lineNo, columnNo, error }]);
        return false;
    };

    const submitFeedback = async () => {
        const validationErrors = await validator.getErrors(feedback, validation);
        setErrors(validationErrors);
        if (Object.keys(validationErrors).length > 0) {
            return;
        }
        let feedbackData = { ...feedback };
        if (!feedbackData.canContact) delete feedbackData.email;
        if (feedbackData.diagnostic) {
            feedbackData.errs = JSON.stringify(pageErrs);
        }

        try {
            console.log("feedbackData:", feedbackData);
            await api.post("/feedback", { data: feedbackData });
            setFeedback({ canContact: false });
            setShowSuccessMessage(true)
            message.success("Your feedback was successfully submitted. Thank you!");

            // Close the modal after a delay
            setTimeout(() => {
                setShowSuccessMessage(false);
                onClose();
            }, 2000); // 2 seconds delay

        } catch (error) {
            console.error(error);
            alert('Error submit feedback!');
        }

    };

   
    return (
        <Modal show={show} onHide={onClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Submit feedback</Modal.Title>
            </Modal.Header>
            <Modal.Body className="py-3" style={{ width: "90%", margin: "0 auto" }}>
                {showSuccessMessage ? (
                    <div className="alert alert-success">
                        Your feedback was successfully submitted. Thank you!
                    </div>
                ) : (


                    <div className="mb-3">
                        <span className="form-label">
                            Below you can enter any comments, questions, or concerns with our site.
                        </span>
                        <Form.Group className="mt-3">
                            <Form.Label>Name:</Form.Label>
                            <Form.Control
                                type="text"
                                required
                                isInvalid={!!errors.name}
                                value={feedback.name || ''}
                                onChange={(e) => setFeedback({ ...feedback, name: e.target.value })}
                            />
                            <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="mt-1">
                            <Form.Check
                                type="checkbox"
                                label="I'd like to make myself available by email for follow-up questions."
                                checked={feedback.canContact}
                                onChange={(e) => setFeedback({ ...feedback, canContact: e.target.checked })}
                            />
                        </Form.Group>
                        {feedback.canContact && (
                            <Form.Group className="mt-3">
                                <Form.Label>Email:</Form.Label>
                                <Form.Control
                                    type="email"
                                    required
                                    isInvalid={!!errors.email}
                                    value={feedback.email || ''}
                                    onChange={(e) => setFeedback({ ...feedback, email: e.target.value })}
                                />
                                <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                            </Form.Group>
                        )}
                        <Form.Group className="mt-3">
                            <Form.Label>Feedback:</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={4}
                                required
                                isInvalid={!!errors.text}
                                value={feedback.text || ''}
                                onChange={(e) => setFeedback({ ...feedback, text: e.target.value })}
                                placeholder="Enter your comments, questions, or concerns..."
                            />
                            <Form.Control.Feedback type="invalid">{errors.text}</Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="mt-2">
                            <Form.Check
                                type="checkbox"
                                label="I grant permission to AccessEVA.ai to access my session diagnostics so that my submitted feedback may be addressed."
                                checked={feedback.diagnostic}
                                onChange={(e) => setFeedback({ ...feedback, diagnostic: e.target.checked })}
                            />
                        </Form.Group>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                {!showSuccessMessage && (
                    <>
                        <Button variant="primary" onClick={submitFeedback}>
                            Submit
                        </Button>
                        <Button variant="secondary" onClick={onClose}>
                            Cancel
                        </Button>
                    </>
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default FeedbackView;